<template>
  <div class="container">
    <van-nav-bar title="充值记录" left-text="" left-arrow @click-left="onClickLeft">
    </van-nav-bar>
    <van-row style="background:#fff">
      <van-col span="8">
        <p class="p1">充值总金额</p>
        <p class="p2 col_o">￥{{statistics.totalAmounts}}</p>
      </van-col>
      <van-col span="8">
        <p class="p1">赠送总金额</p>
        <p class="p2 col_g">￥{{statistics.givingAmounts}}</p>
      </van-col>
      <van-col span="8">
        <p class="p1">实付总金额</p>
        <p class="p2 col_r">￥{{statistics.payAmounts}}</p>
      </van-col>
    </van-row>

      <van-field v-model="keyword" left-icon="search" center :clearable="true" label="" placeholder="请输入订单编号或电话号码">
        <template #button>
          <van-button size="small" type="primary" @click="pageIndex = 1;getProjectList();">搜索</van-button>
        </template>
      </van-field>
  
    <div class="menu">
      <div class="menuitem" @click="showPicker(2)">{{communityName || '所属项目'}}<van-icon :name="showPopup?'arrow-up':'arrow-down'" /></div>
      <div class="menuitem" @click="showPicker(1)">{{statusName || '订单时间'}}<van-icon :name="showPopup?'arrow-up':'arrow-down'" /></div>
    </div>
    <van-popup v-model="showPopup" :close-on-click-overlay='false' round position="bottom">
      <van-picker show-toolbar :columns="columns" value-key="name" @cancel="onCancel" @confirm="onConfirm"
        @change="onChange" />
    </van-popup>
    <van-list v-model="loading" :finished="finished" :finished-text="projectList.length > 0?'没有更多了':'暂无数据'"
      @load="onLoad">
      <div class="list-box">
        <div class="list clearfix" @click="changePage(item)" :key="index" v-for="(item,index) in projectList">
          <div class="fl_left">
            <div class="mg10">项目：{{item.communityName}}</div>
            <div class="mg10">手机号码：{{item.mobile}}</div>
            <div class="mg10">订单编号：{{item.id}}</div>
            <div class="mg10">订单时间：{{item.createTime}}</div>
          </div>
          <div class="fl_right">
            <div class="mg10">
              <p class="col_o list-p1"><i>￥</i>{{item.payAmount}}</p>
              <p class="list-p2 col_b">详情</p>
            </div>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import axios from '@/axios.js';
import moment from "moment";
import { NavBar, Icon, Toast, Loading, Picker, Field, Popup, List, Button, Col, Row,Cell, CellGroup } from 'vant';
export default {
  data() {
    return {
      allCount: 0,
      pageIndex: 1,
      pageSize: 10,
      loading: false,
      finished: false,
      projectList: [],
      cityCode: '410100',
      status: undefined,
      communityId: undefined,
      communityName: '',
      statusName: '',
      statistics:{},
      keyword: '',
      showPopup: false,
      selIndex: '',
      columns: [],
      statusList: [
        { name: '近7天', value: 7 },
        { name: '近30天', value: 30 },
        { name: '近90天', value: 90 },
      ],
      startTime: '',
      endTime: '',
      cityList: [],
      communityList: [],
    };
  },
  components: {
    [NavBar.name]: NavBar,
    [Icon.name]: Icon,
    [Toast.name]: Toast,
    [Loading.name]: Loading,
    [Field.name]: Field,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [List.name]: List,
    [Button.name]: Button,
    [Col.name]: Col,
    [Row.name]: Row,

    [CellGroup .name]: CellGroup ,
  },
  methods: {
    changePage(item) {
      this.$router.push({ path: "rechargeDetail.html", query: { id: item.id } })
    },
    showPicker(type) {
      this.selIndex = type;
      if (type == 1) {
        this.columns = this.statusList;
        this.showPopup = true;
      } else {
        this.columns = [
          // 第一列
          {
            values: this.cityList,
            defaultIndex: 0,
          },
          // 第二列
          {
            values: this.communityList,
            defaultIndex: 0,
          },
        ];
        this.showPopup = true;
      }
    },
    onChange(picker, item, index) {
      if (this.selIndex == 2 && index == 0) {
        this.cityCode = item[0].id;
        this.getCommunityList(picker);
      }
    },
    onCancel() {
      //取消
      if (this.selIndex == 1) {
        this.statusName = '';
        this.startTime = '';
      } else {
        this.communityName = '';
        this.communityId = undefined;
      }
      this.showPopup = false;
      this.projectList=[]
      this.finished=false
      this.pageIndex = 1;
      this.getProjectList();
    },
    onConfirm(item) {
      if (this.selIndex == 1) {
        this.statusName = '订单时间:' + item.name;
        this.startTime = moment().startOf("day").subtract(item.value, 'days').format('YYYY-MM-DD 00:00:00')
      } else {
        this.communityName = item[1].name;
        this.communityId = [item[1].id];
      }
      this.pageIndex = 1;
      this.finished = false;
      this.getProjectList();
      this.showPopup = false;
    },
    getCityList() {
      axios.get("/common/getcitylist?proviceId=410000").then((res) => {
        this.cityList = res.data;
      })
    },
    getCommunityList(picker) {
      axios.post("/common/getcommunitylistbycitycode", {
        cityCode: this.cityCode,
      }).then((res) => {
        if (res.data.length > 0) {
          res.data.forEach(item => {
            item.name = item.communityName
            item.id = item.communityId
          })
        }
        this.communityList = res.data;
        if (picker) {
          picker.setColumnValues(1, res.data);
        }

      })
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.pageIndex++;
        this.getMoreList();
      }, 500)
    },
    getProjectList() {
      this.loading = true;
      axios.post("/recharge/pagelist", {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        filter: {
          communityIds: this.communityId,
          keyword: this.keyword,
          startTime: this.startTime,
          endTime: moment().format("YYYY-MM-DD 23:59:59"),
        }
      }).then((res) => {
        // 加载状态结束
        this.loading = false;
        this.projectList = res.data.pages.list;
        this.allCount = res.data.pages.total;
        this.statistics = res.data.statistics;
      })
    },
    getMoreList() {
      axios.post("/recharge/pagelist", {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        filter: {
          communityIds: this.communityId,
          keyword: this.keyword,
          startTime: this.startTime,
          endTime: moment().format("YYYY-MM-DD 23:59:59"),
        }
      }).then((res) => {
        this.projectList = this.projectList.concat(res.data.pages.list);
        this.allCount = res.data.pages.total;
        // 加载状态结束
        this.loading = false;
        // 数据全部加载完成
        if (this.pageIndex * this.pageSize >= this.allCount) {
          this.finished = true;
        }
      })
    },
    onClickLeft() {
      this.$router.replace({ path: "home.html" });
    },
  },
  computed: {
  },
  watch: {//使用watch 监听$router的变化
    $route(to, from) {
      if(from.name == 'home'){
        this.keyword = '';
        this.communityName = '';
        this.communityId = undefined;
        this.status = 7;
        this.statusName = '订单时间:近7天';
        this.startTime = moment().startOf("day").subtract(7, 'days').format('YYYY-MM-DD 00:00:00');
        this.getProjectList();
      }
    }
  },
  created() {
    this.status = 7;
    this.statusName = '订单时间:近7天';
    this.startTime = moment().startOf("day").subtract(7, 'days').format('YYYY-MM-DD 00:00:00');
    this.getProjectList();
  },
  mounted() {
    setTimeout(()=>{
      this.getCityList();
      this.getCommunityList();
    },500)
  },
  destroyed() { }
}
</script>
<style lang="less" scoped>
body,
html {
  width: 100%;
  height: 100%;
  background: #F0F4F7
}

.container {
  width: 100%;
  height: 100%;
  letter-spacing: 0px;
  background: #F0F4F7;
}

.list-box {
  width: 100%;
  color: #373737;

  .list {
    font-size: 14px;
    width: 100%;
    background: #fff;
    margin: 12px 0;
    padding: 12px;

    .fl_right {
      text-align: right;
      margin-top: 15px;
    }
    &-p1{
      font-size: 24px;
      font-weight: 600;
      line-height: 2;
      i{
        font-size: 14px;
      }
    }
    &-p2{
      font-size: 13px;
      padding-top: 10px;
    }
  }

  .mg10 {
    margin-bottom: 10px;
  }

  .bold {
    font-weight: bold;
  }
}

.menu {
  width: 100%;
  height: 54px;
  line-height: 54px;
  text-align: center;
  background: #fff;

  .menuitem {
    width: 50%;
    display: inline-block;
  }
}
.p1,.p2{
  text-align: center;
}
.p1{
  line-height: 1.5;
  padding-top: 15px;
  font-size: 13px;
}
.p2{
  line-height: 2;
  font-size: 18px;
  font-weight: 600;
}
</style>
